import React, { useEffect, useRef } from 'react';

const FloatingSquares = () => {
  const containerRef = useRef(null);
  const squaresRef = useRef([]);
  const animationRef = useRef(null);
  
  // Enhanced colors with higher opacity to match the reference image
  const colors = [
    'rgba(100, 150, 100, 0.35)', // muted green with higher opacity
    'rgba(150, 100, 100, 0.35)', // muted red with higher opacity
    'rgba(150, 140, 90, 0.35)',  // khaki with higher opacity
    'rgba(70, 90, 40, 0.4)',     // darker green
    'rgba(120, 60, 60, 0.4)',    // darker red
  ];
  
  useEffect(() => {
    if (!containerRef.current) return;
    
    const container = containerRef.current;
    
    // Create more squares for better visibility
    const squareCount = Math.floor(window.innerWidth / 40); // Increased density
    const squares = [];
    
    for (let i = 0; i < squareCount; i++) {
      const square = document.createElement('div');
      square.className = 'floating-square';
      
      // Random size between 15px and 120px (bigger squares)
      const size = Math.random() * 105 + 15;
      square.style.width = `${size}px`;
      square.style.height = `${size}px`;
      
      // Random position
      square.style.left = `${Math.random() * 100}vw`;
      square.style.top = `${Math.random() * 100}vh`;
      
      // Random color
      square.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      
      // Slower speed for a more subtle effect
      const speedX = (Math.random() - 0.5) * 0.15;
      const speedY = (Math.random() - 0.5) * 0.15;
      
      // Random rotation
      const rotation = Math.random() * 360;
      square.style.transform = `rotate(${rotation}deg)`;
      
      // Enhanced 3D effect with better z-index distribution
      const zIndex = Math.floor(Math.random() * 3);
      square.style.zIndex = zIndex;
      
      // Add slight border to enhance sticky note appearance
      square.style.border = '1px solid rgba(255, 255, 255, 0.1)';
      
      // Store properties for animation
      squares.push({
        element: square,
        x: parseFloat(square.style.left),
        y: parseFloat(square.style.top),
        speedX,
        speedY,
        rotation,
        rotationSpeed: (Math.random() - 0.5) * 0.08
      });
      
      container.appendChild(square);
    }
    
    squaresRef.current = squares;
    
    // Animation loop
    const animate = () => {
      squaresRef.current.forEach(square => {
        // Update position
        square.x += square.speedX;
        square.y += square.speedY;
        
        // Update rotation
        square.rotation += square.rotationSpeed;
        
        // Apply transforms
        square.element.style.left = `${square.x}vw`;
        square.element.style.top = `${square.y}vh`;
        square.element.style.transform = `rotate(${square.rotation}deg)`;
        
        // Wrap around edges
        if (square.x < -10) square.x = 110;
        if (square.x > 110) square.x = -10;
        if (square.y < -10) square.y = 110;
        if (square.y > 110) square.y = -10;
      });
      
      animationRef.current = requestAnimationFrame(animate);
    };
    
    animate();
    
    // Cleanup
    return () => {
      cancelAnimationFrame(animationRef.current);
      squaresRef.current.forEach(square => {
        if (square.element.parentNode) {
          square.element.parentNode.removeChild(square.element);
        }
      });
    };
  }, []);
  
  return <div ref={containerRef} className="fixed inset-0 overflow-hidden" />;
};

export default FloatingSquares;